import {api} from './api';

export const getOperacoesApi = (plataforma: string | null) => {
    return api.get('operacoes/', {params:{plataforma}}).then(res => res.data.operacao)
}